import {useMutation, useQueryClient} from "@tanstack/react-query";
import {updateProductDetailImageIn} from "../../../../../api/product/ProductInApi";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";


export const useUpdateProductDetailImageIn = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: FormData) => updateProductDetailImageIn(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "저장되었습니다",
                type: "alert",
            });

            qc.invalidateQueries({queryKey: ["readProductDetailIn"]})
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
